<div class='buyer-create-v2-shell tenant-buyer-create-v2-shell'>
  <div class='buyer-create-v2-hidden'>
    <ngx-buyer-create
      [cities]='cities'
      [taskTypes]='taskTypes'
      [taskStatuses]='taskStatuses'
      (navigateBuyerEvent)='navigateBuyerEvent.emit($event)'
      (editDone)='editDone.emit($event)'
      (newDone)='newDone.emit($event)'
      (reserveBuyer)='reserveBuyer.emit($event)'
      (ownSet)='ownSet.emit($event)'>
    </ngx-buyer-create>
  </div>

  <form *ngIf='buyerCreate?.buyerForm as buyerForm' [formGroup]='buyerForm'>
    <nb-card class='border-0 background-color-v2 prospect-dialog-card buyer-create-v2-card'>
      <nb-card-header class='header-card'>
        <div class='buyer-header'>
          <div class='buyer-header-row'>
            <button type='button' nbButton size='large'
                    class='large max-right mobile-view buyer-back-button'
                    (click)='back()'>
              <nb-icon icon='arrow-back-outline' pack='eva'></nb-icon>
            </button>

            <div class='name-line'>
              <ng-container *ngIf='!isBlank'>
                <span class='buyer-name-text'>{{ displayName() }}</span>
                <span class='compact-buyer-code'>({{ buyerForm.controls?.buyerCode?.value || 'T' }})</span>
              </ng-container>
            </div>

            <div class='buyer-header-actions'>
              <div class='buyer-mode-toggle'>
                <button type='button' nbButton size='tiny' class='buyer-mode-button'
                        [ngClass]="{'buyer-mode-button-active': buyerForm.controls?.isWot?.value}"
                        [status]='buyerForm.controls?.isWot?.value ? "info" : "basic"'
                        (click)='toggleWot()'>WOT</button>
                <button type='button' nbButton size='tiny' class='buyer-mode-button'
                        [ngClass]="{'buyer-mode-button-active': buyerForm.controls?.buyerCode?.value === 'B' || buyerForm.controls?.buyerCode?.value === 'VB'}"
                        [status]='buyerForm.controls?.buyerCode?.value === "B" || buyerForm.controls?.buyerCode?.value === "VB" ? "info" : "basic"'
                        (click)='setBuyerMode("buyer")'>B</button>
                <button type='button' nbButton size='tiny' class='buyer-mode-button'
                        [ngClass]="{'buyer-mode-button-active': buyerForm.controls?.buyerCode?.value === 'T'}"
                        [status]='buyerForm.controls?.buyerCode?.value === "T" ? "info" : "basic"'
                        (click)='setBuyerMode("tenant")'>T</button>
              </div>
            </div>
          </div>
          <div class='buyer-header-address'></div>
        </div>
      </nb-card-header>

      <nb-card-body class='padding-override'>
        <div class='row m-0 mt-2'>
          <div class='col-12 d-flex justify-content-center p-1'>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details'
                      (click)='buyerCreate.setSquareValue("mail")'>
                <span [ngClass]='buyerForm.controls.mail.value ? "line-through" : ""'>Mail</span>
              </button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details'
                      (click)='buyerCreate.setSquareValue("call")'>
                <span [ngClass]='buyerForm.controls.call.value ? "line-through" : ""'>Call</span>
              </button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details'
                      (click)='buyerCreate.setSquareValue("sms")'>
                <span [ngClass]='buyerForm.controls.sms.value ? "line-through" : ""'>Sms</span>
              </button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='button-details buyer-active-toggle'
                      [ngClass]="{'buyer-active-toggle-inactive': activeStatusLabel() === 'INACTIVE'}"
                      (click)='toggleActiveStatus()'>{{ activeStatusLabel() }}</button>
            </div>
          </div>

          <div class='col-12 d-flex justify-content-center p-1 mt-2'>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='custom-client-detail-back-button'
                      (click)='navigateBuyer(false)'>BACK</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='button-details'
                      (click)='noAnswerAndNext()'>NA</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='button-details'
                      (click)='createTask()'>APP</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='custom-client-detail-next-button'
                      (click)='navigateBuyer(true)'>NEXT</button>
            </div>
          </div>

          <div class='col-12 d-flex justify-content-center p-1 mt-2 buyer-section-switcher'>
            <div class='col text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='border section-toggle-button buyer-letter-toggle'
                      [ngClass]="{'section-toggle-button-active': !isBlank && isSectionView && activeSection === 'T'}"
                      [status]='!isBlank && isSectionView && activeSection === "T" ? "primary" : "basic"'
                      (click)='setActiveSection("T")'>T</button>
            </div>
            <div class='col text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='border section-toggle-button buyer-letter-toggle'
                      [ngClass]="{'section-toggle-button-active': !isBlank && isSectionView && activeSection === 'A'}"
                      [status]='!isBlank && isSectionView && activeSection === "A" ? "primary" : "basic"'
                      (click)='setActiveSection("A")'>A</button>
            </div>
            <div class='col text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='border section-toggle-button buyer-letter-toggle'
                      [ngClass]="{'section-toggle-button-active': !isBlank && isSectionView && activeSection === 'P'}"
                      [status]='!isBlank && isSectionView && activeSection === "P" ? "primary" : "basic"'
                      (click)='setActiveSection("P")'>P</button>
            </div>
            <div class='col text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='border section-toggle-button buyer-letter-toggle'
                      [ngClass]="{'section-toggle-button-active': !isBlank && isSectionView && activeSection === 'L'}"
                      [status]='!isBlank && isSectionView && activeSection === "L" ? "primary" : "basic"'
                      (click)='setActiveSection("L")'>L</button>
            </div>
          </div>

          <ng-container *ngIf='!isSectionView || isCreateMode'>
            <div class='col-12 buyer-main-view tenant-main-view'>
              <div class='row custom-area m-1 mt-2 tenant-agent-note-composer'
                   *ngIf='!isBlank && !isCreateMode && !isBulkUpdateMode'>
                <div class='col-12 p-2'>
                  <div class='tenant-agent-note-input-wrapper'>
                    <textarea nbInput fullWidth rows='3'
                              class='tenant-agent-note-input'
                              [(ngModel)]='newAgentNote'
                              [ngModelOptions]='{standalone: true}'
                              maxlength='2000'
                              placeholder='Agent note'></textarea>
                    <button type='button' nbButton size='tiny' status='primary'
                            class='tenant-agent-note-save'
                            [disabled]='isSavingAgentNote || !newAgentNote?.trim()'
                            (click)='saveAgentNote()'>SAVE</button>
                  </div>
                </div>
              </div>
              <div class='row custom-area m-1 mt-2 tenant-history-note'
                   *ngIf='!isBlank && !isCreateMode && !isBulkUpdateMode'>
                <div class='col-12'>
                  <div class='row m-0 p-2'>
                    <div class='col-12 text-center buyer-section-title'>HISTORY NOTE</div>
                  </div>
                  <ng-container *ngIf='sortedAgentNotes() as agentNotes'>
                    <div class='row m-0 px-2 py-1 tenant-history-note-row'
                         *ngFor='let agentNote of agentNotes'>
                      <div class='col-4 tenant-history-note-date'>
                        {{ formatAgentNoteDate(agentNote.createdDate) }}
                      </div>
                      <div class='col-8 tenant-history-note-text'>{{ agentNote.note }}</div>
                    </div>
                    <div class='row m-0 px-2 py-1 tenant-history-note-empty'
                         *ngIf='agentNotes.length === 0'>
                      <div class='col-12'>No history notes.</div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>

          <div class='col-12 mt-2' *ngIf='isCreateMode || (isSectionView && activeSection === "T")'>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12 text-center buyer-section-title'>TENANT</div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Full Name</div>
                  <div class='col-12 mt-1'>
                    <input type='text' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           [value]='displayName()'
                           readonly
                           placeholder='Full name'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Contact Number</div>
                  <div class='col-12 mt-1'>
                    <input type='tel' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='mobilePhone' placeholder='Contact number'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Email</div>
                  <div class='col-12 mt-1'>
                    <input type='email' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='email' placeholder='Email Address'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>
                    <div>Enquiry Date</div>
                    <nb-form-field>
                      <input [nbDatepicker]='tenantEnquiryDatePicker' nbInput fieldSize='tiny'
                             fullWidth class='no-border-input tenant-section-input'
                             formControlName='enqDate2' placeholder='Enquiry date'/>
                      <nb-datepicker #tenantEnquiryDatePicker></nb-datepicker>
                    </nb-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2 align-items-center'>
                  <div class='col-10'>
                    <div>Enquiry Address</div>
                    <input type='text' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           [readonly]='isBulkUpdateMode'
                           formControlName='enqAddress' placeholder='Enquiry address'>
                  </div>
                  <div class='col-2 text-right d-flex align-items-center justify-content-end'>
                    <button type='button' nbButton size='tiny'
                            class='button-details tenant-enq-button'
                            (click)='buyerCreate.selectAddress()'>ENQ</button>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Rent Per Week</div>
                  <div class='col-6 mt-1 pr-1'>
                    <input type='number' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='minBuyPrice' placeholder='Min rent per week'>
                  </div>
                  <div class='col-6 mt-1 pl-1'>
                    <input type='number' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='maxBuyPrice' placeholder='Max rent per week'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Date Count</div>
                  <div class='col-12 mt-1'>
                    <input type='text' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           [value]='dateCountText()' placeholder='Date count' readonly>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Preferred Area</div>
                  <div class='col-12 mt-1'>
                    <input nbInput fullWidth fieldSize='tiny'
                           class='no-border-input tenant-section-input'
                           placeholder='Select postcode'
                           inputmode='numeric' maxlength='4'
                           [(ngModel)]='buyerCreate.preferredPostcodeInput'
                           [ngModelOptions]='{standalone: true}'
                           [typeahead]='buyerCreate.filterPreferredPostcode$'
                           [typeaheadAsync]='true'
                           (typeaheadOnSelect)='buyerCreate.selectPreferredPostcode($event)'
                           typeaheadOptionField='code'
                           typeaheadMinLength='2'
                           typeaheadWaitMs='300'>
                  </div>
                  <div class='col-12 buyer-preferred-list' *ngIf='buyerCreate.preferredAreas.length'>
                    <span class='buyer-preferred-chip' *ngFor='let postcode of buyerCreate.preferredAreas'>
                      {{ postcode }}
                      <button type='button' aria-label='Remove postcode'
                              (click)='buyerCreate.removePreferredPostcode(postcode)'>&times;</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Note</div>
                  <div class='col-12 mt-1'>
                    <textarea rows='3' nbInput cdkTextareaAutosize cdkAutosizeMinRows='2'
                              cdkAutosizeMaxRows='5' fullWidth
                              class='resize-textarea no-border-input tenant-section-input tenant-section-textarea'
                              formControlName='note' placeholder='Note'></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class='col-12 mt-2' *ngIf='isCreateMode || (isSectionView && activeSection === "A")'>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12 text-center buyer-section-title'>ID</div>
                  <div class='col-6 mt-2'>
                    <nb-checkbox formControlName='tenantHasDriverLicense'>Driver License</nb-checkbox>
                  </div>
                  <div class='col-6 mt-2'>
                    <nb-checkbox formControlName='tenantHasPassport'>Passport</nb-checkbox>
                  </div>
                </div>
              </div>
            </div>

            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12 text-center buyer-section-title'>FINANCIAL</div>
                  <div class='col-6 mt-2'>
                    <nb-checkbox formControlName='tenantHasBankStatement'>Bank Statement</nb-checkbox>
                  </div>
                  <div class='col-6 mt-2'>
                    <div>Payslip</div>
                    <input type='number' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantPayslipCount' placeholder='Payslips'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Total Income</div>
                  <div class='col-12 mt-1'>
                    <input type='number' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantTotalIncome' placeholder='Total income'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Affordability Ratio</div>
                  <div class='col-12 mt-1'>
                    <input type='number' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantAffordabilityRatio' placeholder='Affordability ratio'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12 text-center buyer-section-title'>RENTAL HISTORY</div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2 tenant-rental-history-group'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12 text-center buyer-section-subtitle'>CURRENT RENTAL</div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Address</div>
                  <div class='col-12 mt-1 tenant-rental-address-row'>
                    <input type='text' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantCurrentRentalAddress' placeholder='Current rental address'>
                    <button type='button' nbButton size='tiny' status='primary'
                            class='tenant-rental-lookup-button'
                            (click)='lookupRentalAddress("Current")'>Look up</button>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Rent Per Week</div>
                  <div class='col-12 mt-1'>
                    <input type='number' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantCurrentRentPerWeek' placeholder='Rent per week'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Rental Brand</div>
                  <div class='col-12 mt-1'>
                    <select class='form-select select-custom'
                            [ngModel]='currentRentalBrand' [ngModelOptions]='{standalone: true}'
                            (ngModelChange)='onCurrentRentalBrandChange($event)'>
                      <option [ngValue]='null'>Rental Brand</option>
                      <option *ngFor='let brand of companyBrands' [ngValue]='brand'>{{ brand }}</option>
                    </select>
                  </div>
                  <div class='col-12 mt-2'>
                    <select class='form-select select-custom' formControlName='tenantCurrentCompanyId'
                            [attr.disabled]='!currentRentalBrand ? true : null'>
                      <option [ngValue]='null'>Rental Company</option>
                      <option *ngFor='let company of currentRentalCompanies'
                              [ngValue]='company.companyId'>{{ company.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Reason Of Leaving</div>
                  <div class='col-12 mt-1'>
                    <input type='text' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantCurrentReasonOfLeaving' placeholder='Reason of leaving'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2 tenant-rental-history-group'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12 text-center buyer-section-subtitle'>PREVIOUS RENTAL</div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Address</div>
                  <div class='col-12 mt-1 tenant-rental-address-row'>
                    <input type='text' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantPreviousRentalAddress' placeholder='Previous rental address'>
                    <button type='button' nbButton size='tiny' status='primary'
                            class='tenant-rental-lookup-button'
                            (click)='lookupRentalAddress("Previous")'>Look up</button>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Rent Per Week</div>
                  <div class='col-12 mt-1'>
                    <input type='number' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantPreviousRentPerWeek' placeholder='Rent per week'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Rental Brand</div>
                  <div class='col-12 mt-1'>
                    <select class='form-select select-custom'
                            [ngModel]='previousRentalBrand' [ngModelOptions]='{standalone: true}'
                            (ngModelChange)='onPreviousRentalBrandChange($event)'>
                      <option [ngValue]='null'>Rental Brand</option>
                      <option *ngFor='let brand of companyBrands' [ngValue]='brand'>{{ brand }}</option>
                    </select>
                  </div>
                  <div class='col-12 mt-2'>
                    <select class='form-select select-custom' formControlName='tenantPreviousCompanyId'
                            [attr.disabled]='!previousRentalBrand ? true : null'>
                      <option [ngValue]='null'>Rental Company</option>
                      <option *ngFor='let company of previousRentalCompanies'
                              [ngValue]='company.companyId'>{{ company.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Reason Of Leaving</div>
                  <div class='col-12 mt-1'>
                    <input type='text' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantPreviousReasonOfLeaving' placeholder='Reason of leaving'>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class='col-12 mt-2' *ngIf='isCreateMode || (isSectionView && activeSection === "P")'>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12 text-center buyer-section-title'>PROOF</div>
                  <div class='col-12 mt-2'>
                    <nb-checkbox formControlName='tenantHasOwnerApproval'>Owner approval</nb-checkbox>
                  </div>
                  <div class='col-12 mt-2'>
                    <nb-checkbox formControlName='tenantHasDeposit'>{{ depositLabelText() }}</nb-checkbox>
                  </div>
                  <div class='col-12 mt-2'>
                    <nb-checkbox formControlName='tenantHasBond'>{{ bondLabelText() }}</nb-checkbox>
                  </div>
                  <div class='col-12 mt-1'>
                    <input type='number' nbInput fieldSize='tiny' fullWidth
                           class='no-border-input tenant-section-input'
                           formControlName='tenantBondAmount' placeholder='Bond amount'>
                  </div>
                  <div class='col-12 mt-2'>Bond Payment Date</div>
                  <div class='col-12 mt-1'>
                    <nb-form-field>
                      <input [nbDatepicker]='tenantBondPaymentDatePicker' nbInput fieldSize='tiny'
                             fullWidth class='no-border-input tenant-section-input'
                             formControlName='tenantBondDate' placeholder='Bond payment date'/>
                      <nb-datepicker #tenantBondPaymentDatePicker></nb-datepicker>
                    </nb-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class='col-12 mt-2' *ngIf='isCreateMode || (isSectionView && activeSection === "L")'>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Leased Date</div>
                  <div class='col-12 mt-1'>
                    <nb-form-field>
                      <input [nbDatepicker]='tenantMoveInDatePicker' nbInput fieldSize='tiny'
                             fullWidth class='no-border-input tenant-section-input'
                             formControlName='tenantMoveInDate' placeholder='Leased date'/>
                      <nb-datepicker #tenantMoveInDatePicker></nb-datepicker>
                    </nb-form-field>
                  </div>
                  <div class='col-12 mt-2'>Expire Date</div>
                  <div class='col-12 mt-1'>
                    <nb-form-field>
                      <input [nbDatepicker]='tenantExpireDatePicker' nbInput fieldSize='tiny'
                             fullWidth class='no-border-input tenant-section-input'
                             formControlName='tenantExpireDate' placeholder='Expire date'/>
                      <nb-datepicker #tenantExpireDatePicker></nb-datepicker>
                    </nb-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nb-card-body>

      <nb-card-footer class='mb-2 p-0 mt-2 border-top-0 buyer-create-v2-footer'>
        <div class='col-12 d-inline-flex justify-content-center mt-2'>
          <div class='override-width p-1 text-center'>
            <button type='button' nbButton fullWidth size='medium'
                    class='custom-button-footer d-block p-0 text-center button-details'
                    (click)='new()'>
              <nb-icon icon='plus-outline' pack='eva' class='m-0'></nb-icon>
              <div class='text-center mt-2'>New</div>
            </button>
          </div>
          <div class='override-width p-1 text-center'>
            <button type='button' nbButton fullWidth size='medium'
                    class='custom-button-footer d-block p-0 text-center button-details'
                    [nbPopover]='tag'>
              <nb-icon icon='pricetags-outline' pack='eva' class='m-0'></nb-icon>
              <div class='text-center mt-2'>Tag</div>
            </button>
          </div>
          <div class='override-width p-1 text-center'>
            <button type='button' nbButton fullWidth size='medium'
                    class='custom-button-footer d-block p-0 text-center button-details'
                    (click)='save()'
                    [disabled]='buyerCreate?.isUpdating === true'>
              <nb-icon icon='save-outline' pack='eva' class='m-0'></nb-icon>
              <div class='text-center mt-2'>{{ isBulkUpdateMode ? 'Save All' : 'Save' }}</div>
            </button>
          </div>
        </div>
      </nb-card-footer>
    </nb-card>
  </form>
</div>

<ng-template #tag>
  <div class='row m-0 p-2 buyer-tag-popover' *ngIf='buyerCreate'>
    <div class='col-12'>
      <input
        [(ngModel)]='buyerCreate.categoryName'
        [ngModelOptions]='{standalone: true}'
        [typeahead]='buyerCreate.filterCategory$'
        [typeaheadAsync]='true'
        (typeaheadOnSelect)='buyerCreate.selectCategory($event)'
        typeaheadOptionField='name'
        typeaheadWaitMs='1000'
        placeholder='Search Tag'
        nbInput fieldSize='tiny' fullWidth>
    </div>
    <div class='col-12 mt-2'>
      <div *ngFor='let category of buyerCreate.selectedCategories' class='category-block buyer-tag-item mt-2'>
        {{ category.name }}
        <button type='button' class='btn btn-danger btn-sm'
                (mousedown)='$event.stopPropagation()'
                (click)='$event.preventDefault(); $event.stopPropagation(); buyerCreate.removeCategory(category)'>
          <i class='fa fa-times' aria-hidden='true'></i>
        </button>
      </div>
    </div>
  </div>
</ng-template>
